import axios from 'axios';
import { getInitialApiOrigin, getNextApiOrigin, persistApiOrigin } from './apiHost';

const initialOrigin = getInitialApiOrigin();

const api = axios.create({
  baseURL: `${initialOrigin}/api`,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('erp_token');

    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => {
    if (response?.config?.baseURL) {
      const origin = response.config.baseURL.replace(/\/api\/?$/, '');
      persistApiOrigin(origin);
    }
    return response;
  },
  (error) => {
    const config = error?.config;
    const method = (config?.method || 'get').toLowerCase();
    const isIdempotentMethod = ['get', 'head', 'options'].includes(method);

    // Retry em outra porta quando houver erro de rede (backend em 5002/5003, por exemplo)
    if (!error?.response && config && isIdempotentMethod) {
      const currentOrigin = (config.baseURL || api.defaults.baseURL || '').replace(/\/api\/?$/, '');
      const attempted = config._attemptedApiOrigins || [currentOrigin];
      const nextOrigin = getNextApiOrigin(currentOrigin, attempted);

      if (nextOrigin) {
        config._attemptedApiOrigins = [...attempted, nextOrigin];
        config.baseURL = `${nextOrigin}/api`;
        api.defaults.baseURL = `${nextOrigin}/api`;
        persistApiOrigin(nextOrigin);
        return api.request(config);
      }
    }

    const status = error?.response?.status;
    const requestUrl = error?.config?.url || '';
    const isLoginEndpoint = requestUrl.includes('/auth/login');

    if (status === 401 && !isLoginEndpoint) {
      localStorage.removeItem('erp_token');
      localStorage.removeItem('erp_usuario');
      localStorage.removeItem('erp_login');
      window.dispatchEvent(new CustomEvent('erp:session-expired'));
    }

    return Promise.reject(error);
  }
);

export default api;
